import {gql} from "@apollo/client";
import {OrderAddressType} from "../../../../../graphql/types/OrderDetailType";

export const CHANGE_ORDER_RECEIVER_ADDRESS = gql`
    mutation OrderMutation($orderId: Long!, $address: OrderAddressTypeInput!) {
        changeOrderReceiverAddress(orderId: $orderId, address: $address) {
            id
            addressLine1
            addressLine2
            city
            state
            zipcode
            fullName
            phoneNumber
            email
            company
            instructions
        }
    }
`;

export interface ChangeOrderReceiverAddressResponse {
    changeOrderReceiverAddress: OrderAddressType;
}

export interface OrderAddressTypeInput {
    input:OrderAddressType;
}

